<template>
    <div class="wrapper">
        <page-header></page-header>
        <router-view></router-view>
    </div>
</template>
<script>
import PageHeader from "@/components/common/PageHeader";

export default {
  name: "Config",
  components: { PageHeader },
  data() {
    return {};
  }
};
</script>
<style scoped>
.wrapper {
  background-color: #f7f7f7;
}
</style>




// WEBPACK FOOTER //
// src/components/page/Config.vue